import { useQuery } from '@tanstack/react-query';
import { queryKeyFactory } from 'utils/query-client';
import { loaders } from './admin-suppliers.loaders';
import { converters } from './admin-suppliers.converters';
import { AdminSuppliersFilters } from './admin-suppliers.types';

export const adminSuppliersKeys = queryKeyFactory('admin-suppliers');

export const useAdminSuppliers = (
  filters: Partial<AdminSuppliersFilters> = {},
) => {
  return useQuery({
    queryKey: adminSuppliersKeys.list(filters),
    queryFn: () => loaders.getSuppliers({ filters }),
    select: converters.getSuppliers,
  });
};

export const useAdminSupplier = (supplierId: string) => {
  return useQuery({
    queryKey: adminSuppliersKeys.detail(supplierId),
    queryFn: () => loaders.getSupplier({ supplierId }),
    select: converters.getSupplier,
    enabled: !!supplierId,
  });
};

export const useAdminSuppliersStatistics = (
  filters: Partial<AdminSuppliersFilters> = {},
) => {
  return useQuery({
    queryKey: adminSuppliersKeys.list('statistics', filters),
    queryFn: () => loaders.getSuppliersStatistics({ filters }),
    select: converters.getSuppliers,
  });
};

export const useAdminPartnerAdmins = (
  supplierId: string,
  { enabled = true }: { enabled?: boolean } = {},
) => {
  return useQuery({
    queryKey: adminSuppliersKeys.detail(supplierId, 'admins'),
    queryFn: () => loaders.getPartnerAdmins({ supplierId }),
    select: converters.getPartnerAdmins,
    enabled: !!supplierId && enabled,
  });
};

export const useAdminPartnerAdmin = (supplierId: string, adminId?: string) => {
  return useQuery({
    queryKey: adminSuppliersKeys.detail(supplierId, 'admins', adminId),
    queryFn: () =>
      loaders.getPartnerAdmin({ supplierId, adminId: adminId ?? '' }),
    select: converters.getPartnerAdmin,
    enabled: !!supplierId && !!adminId,
  });
};

export const useAdminEarningPeriods = (supplierId: string) => {
  return useQuery({
    queryKey: adminSuppliersKeys.detail(supplierId, 'earningPeriods'),
    queryFn: () => loaders.getEarningPeriods({ supplierId }),
    select: converters.getEarningPeriods,
    enabled: !!supplierId,
  });
};
